const getLanguageFromHostname = require('../utils/i18n/getLanguageFromHostname')
const ignoreRoutes = require('./ignoreRoutes')

module.exports = {
  name: 'domain',

  lookup(req, res, options) {
    let language = 'en'

    if (typeof window !== 'undefined') {
      language = getLanguageFromHostname(window.location.hostname)
    } else {
      // For some reason this custom detector is still being called
      // for routes that have been ignored in the NextI18Next
      // configuration. So we’re importing the `ignoreRoutes` array
      // again here and skip any requests to routes defined in there.
      // eslint-disable-next-line security/detect-non-literal-regexp
      if (!new RegExp(ignoreRoutes.join('|')).test(req.originalUrl)) {
        language = getLanguageFromHostname(req.get('host'))
      }
    }

    return language
  },

  cacheUserLanguage(req, res, language, options = {}) {
    //todo
  },
}
